import * as yup from 'yup'

import { getPhoneNumberLength } from '~utilities/locales.utilities'

const noSpace = (x: string) => {
  let quitSpace = ''

  if (x) {
    quitSpace = x.split(' ').join('')
    return quitSpace.split('-').join('')
  }

  return quitSpace
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRegistrationSchema = (t: any, locale: any) => {
  return yup.object({
    firstName: yup
      .string()
      .matches(/^[aA-zZáÁéÉíÍóÓúÚñÑüÜ\s]+$/, t('register.enterValidFirstName'))
      .required(t('register.enterFirstName')),
    lastName: yup
      .string()
      .matches(/^[aA-zZáÁéÉíÍóÓúÚñÑüÜ\s]+$/, t('register.enterValidLastName'))
      .required(t('register.enterLastName')),
    email: yup.string().email(t('register.enterValidEmail')).required(t('register.enterEmail')),
    phone: yup
      .string()
      .required(t('register.enterPhone'))
      .test(
        'phone-validation',
        t('register.enterValidPhone'),
        (value: string | undefined, { createError, path }) => {
          const newValue = noSpace(value as string)
          const { min, max } = getPhoneNumberLength(locale)

          if (!/^\d+$/.test(newValue)) {
            return createError({
              path,
              message: t('register.enterValidPhone'),
            })
          }

          if (min === max && (newValue.length < min || newValue.length > max)) {
            return createError({
              path,
              message: t('register.phoneMustDigits', { number: max }),
            })
          }

          if (min < max && newValue.length < min) {
            return createError({
              path,
              message: t('register.phoneMustLeastDigits', { number: min }),
            })
          }

          if (min < max && newValue.length > max) {
            return createError({
              path,
              message: t('register.phoneMustMostDigits', { number: max }),
            })
          }

          return true
        },
      ),
    confirmPhone: yup.boolean().oneOf([true], t('register.confirmPhoneCheckbox')),
    confirmPrivacy: yup.boolean().oneOf([true], t('register.confirmPrivacyCheckbox')),
  })
}

export type RegistrationSchema = yup.InferType<ReturnType<typeof getRegistrationSchema>>
